module.exports = __webpack_public_path__ + "static/media/mig3.e4c8193c.jpg";